/**
 * FolderCard component - Individual folder card with click handling
 */

import React from 'react';
import { DriveFolder } from '../../types/outreachTemplates';
import FolderIcon from './FolderIcon';

interface FolderCardProps {
  folder: DriveFolder;
}

const FolderCard: React.FC<FolderCardProps> = ({ folder }) => {
  const handleClick = () => {
    window.open(folder.webViewLink, '_blank', 'noopener,noreferrer');
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <article
      className="folder-card"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Open ${folder.name} folder with ${folder.fileCount} file${folder.fileCount !== 1 ? 's' : ''}`}
    >
      <div className="folder-icon-wrapper">
        <FolderIcon color={folder.color} />
      </div>
      <div className="folder-info">
        <h3 className="folder-name">{folder.name}</h3>
        <p className="file-count">
          {folder.fileCount} file{folder.fileCount !== 1 ? 's' : ''}
        </p>
      </div>
    </article>
  );
};

export default FolderCard;

